<template>
  <div :class="['topic', variantClass]">
    <div :class="`topic--${variant}__image`">
      <slot name="image" />
    </div>
    <p
      v-if="hasNumber"
      :class="`topic--${variant}__number`"
    >
      <span>{{ symbolBefore }}</span>
      {{ tweened.toFixed(0) }}
      <span>{{ symbolAfter }}</span>
    </p>
    <p :class="`topic--${variant}__text`">
      <slot name="topic" />
    </p>
  </div>
</template>

<script>
import gsap from 'gsap'

export default {
  name: 'topic',
  props: {
    variant: {
      type: String,
      default: 'primary',
    },
    image: {
      type: String,
    },
    hasNumber: {
      type: Boolean,
      default: false,
    },
    symbolBefore: {
      type: String,
    },
    symbolAfter: {
      type: String,
    },
    number: {
      type: Number,
      default: 0,
    },
    duration: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      tweened: 0,
    }
  },
  computed: {
    variantClass() {
      return this.variant ? `topic--${this.variant}` : ''
    },
  },
  watch: {
    number: {
      immediate: true,
      handler(value) {
        gsap.to(this, { duration: this.duration, tweened: value })
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.topic {
  &--primary {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    max-width: 11.438rem;

    &__image {
      width: 2.5rem;
      height: 2.5rem;
    }

    &__text {
      font-size: 1rem;
      font-weight: 600;
      line-height: 140%;
      color: $neutral-01;

      @media screen and (min-width: 1024px) {
        font-size: 1.25rem;
      }
    }
  }

  &--secondary {
    @include common-topics();

    &__image {
      width: 2rem;
      height: 2rem;
    }

    &__number {
      display: flex;
      gap: 0.125rem;
      font-size: 2.5rem;
      font-weight: 700;
      line-height: 120%;

      @media screen and (min-width: 1024px) {
        font-size: 3rem;
      }
    }

    &__text {
      font-size: 1.375rem;
      font-weight: 400;
      line-height: 160%;
    }
  }

  &--tertiary {
    @include common-topics();
    justify-content: space-between;

    &__image {
      width: 2rem;
      height: 2rem;
    }

    &__text {
      font-size: 1.25rem;
      font-weight: 700;
      line-height: 140%;
    }
  }
}
</style>
